export default {
   components: {
      
   },
   routes: [
      {
         path: '/',
         component: () => import(`./login`),
         name: 'LogIn'
      },
      {
         path: '/verify',
         component: () => import(`./verify-reg`),
         name: 'Verify'
      },
      {
         path: '/forgot-password',
         component: () => import(`./verify-forgot`),
         name: 'ForgotPassword'
      },
      
   ],
   sub_routes: [
      {
         path: '/typography',
         component: () => import(`./typography`),
         name: 'Typography'
      },
      {
         path: '/roles',
         component: () => import(`./roles/role`),
         name: 'Roles'
      },
      // Users
      {
         path: '/users',
         component: () => import(`./users/users`),
         name: 'Users'
      },
   ]
}

export const AuthNav = [
   { 
      icon: 'fa fa-user-tie',component: 'Users', name: 'User Management', has_permission: true,
      children: [
         { icon: 'fa fa-columns',component: 'Roles', name: 'Roles', resource: 'role', has_permission: true},
         { icon: 'fa fa-columns',component: 'Users', name: 'Users', resource: 'user', has_permission: true},
      ]
   },
]